import React from 'react'
import './style.css'

const DonateSection = () => {
    const bankDetails = {
        accountName: "Minangka Deka",
        accountNumber: "63460100002749",
        ifscCode: "BARB0VJBETK",
        micrCode: "781012015",
        bankName: "Bank of Baroda",
        branchName: "Betkuchi"
    };


    return (
        <div className="donate-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="donate-content">
                            {/* Section Title */}
                            <div className="donate-title">
                                <h2>Support Our Mission</h2>
                                <p>Your generous donations help us continue spreading awareness through the art of mime and support our community initiatives.</p>
                            </div>

                            {/* Bank Details Card */}
                            <div className="bank-details-card">
                                <h3>Bank Account Details</h3>
                                
                                <div className="bank-details-grid">
                                    <div className="detail-item">
                                        <label>Account Name</label>
                                        <span className="detail-value">{bankDetails.accountName}</span>
                                    </div>

                                    <div className="detail-item">
                                        <label>Account Number</label>
                                        <span className="detail-value">{bankDetails.accountNumber}</span>
                                    </div>

                                    <div className="detail-item">
                                        <label>IFSC Code</label>
                                        <span className="detail-value">{bankDetails.ifscCode}</span>
                                        <small className="note">Note: Fifth digit is zero (0)</small>
                                    </div>

                                    <div className="detail-item">
                                        <label>MICR Code</label>
                                        <span className="detail-value">{bankDetails.micrCode}</span>
                                    </div>

                                    <div className="detail-item">
                                        <label>Bank Name</label>
                                        <span className="detail-value">{bankDetails.bankName}</span>
                                    </div>

                                    <div className="detail-item">
                                        <label>Branch</label>
                                        <span className="detail-value">{bankDetails.branchName}</span>
                                    </div>
                                </div>

                                <div className="donation-note">
                                    <i className="fa fa-heart"></i>
                                    <p>Every contribution makes a meaningful difference in our mission to create social awareness through mime art. Thank you for your support!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DonateSection;
